import React, { useState, useEffect, useReducer, useContext, useRef } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import Dialog from "@mui/material/Dialog";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from '../../utils/formatSerializedId';
import { v4 as uuidv4 } from "uuid";
import { ArrowDropDown, Backup, ContactPhone } from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";
import ContactImportWpModal from "../../components/ContactImportWpModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AddIcon from '@mui/icons-material/Add';
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const geoUrl = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const markers = [
    { markerOffset: -30, name: "Aracaju", coordinates: [-37.0717, -10.9472] },
    { markerOffset: 15, name: "Belém", coordinates: [-48.4878, -1.4558] },
    { markerOffset: 15, name: "Belo Horizonte", coordinates: [-43.9378, -19.8157] },
    { markerOffset: 15, name: "Boa Vista", coordinates: [-60.6739, 2.8195] },
    { markerOffset: 15, name: "Brasília", coordinates: [-47.8825, -15.7942] },
    { markerOffset: 15, name: "Campo Grande", coordinates: [-54.6464, -20.4428] },
    { markerOffset: 15, name: "Cuiabá", coordinates: [-56.0969, -15.6011] },
    { markerOffset: 15, name: "Curitiba", coordinates: [-49.2736, -25.4296] },
    { markerOffset: 15, name: "Florianópolis", coordinates: [-48.5492, -27.5969] },
    { markerOffset: 15, name: "Fortaleza", coordinates: [-38.5267, -3.71839] },
    { markerOffset: 15, name: "Goiânia", coordinates: [-49.2736, -16.6869] },
    { markerOffset: 15, name: "João Pessoa", coordinates: [-34.8631, -7.1195] },
    { markerOffset: 15, name: "Macapá", coordinates: [-51.0667, 0.0333] },
    { markerOffset: 15, name: "Maceió", coordinates: [-35.7353, -9.6658] },
    { markerOffset: 15, name: "Manaus", coordinates: [-60.025, -3.10194] },
    { markerOffset: 15, name: "Natal", coordinates: [-35.2094, -5.795] },
    { markerOffset: 15, name: "Palmas", coordinates: [-48.3347, -10.1844] },
    { markerOffset: 15, name: "Porto Alegre", coordinates: [-51.23, -30.0331] },
    { markerOffset: 15, name: "Porto Velho", coordinates: [-63.9039, -8.7619] },
    { markerOffset: 15, name: "Recife", coordinates: [-34.8811, -8.05389] },
    { markerOffset: 15, name: "Rio Branco", coordinates: [-67.8099, -9.9747] },
    { markerOffset: 15, name: "Rio de Janeiro", coordinates: [-43.1729, -22.9068] },
    { markerOffset: 15, name: "Salvador", coordinates: [-38.4813, -12.9716] },
    { markerOffset: 15, name: "São Luís", coordinates: [-44.3028, -2.5283] },
    { markerOffset: 15, name: "São Paulo", coordinates: [-46.6333, -23.5505] },
    { markerOffset: 15, name: "Teresina", coordinates: [-42.8039, -5.0892] },
    { markerOffset: 15, name: "Vitória", coordinates: [-40.3378, -20.3194] },
];

const dddList = {
    "11": "São Paulo", "12": "São Paulo", "13": "São Paulo", "14": "São Paulo", "15": "São Paulo", "16": "São Paulo", "17": "São Paulo", "18": "São Paulo", "19": "São Paulo",
    "21": "Rio de Janeiro", "22": "Rio de Janeiro", "24": "Rio de Janeiro",
    "27": "Espírito Santo", "28": "Espírito Santo",
    "31": "Minas Gerais", "32": "Minas Gerais", "33": "Minas Gerais", "34": "Minas Gerais", "35": "Minas Gerais", "37": "Minas Gerais", "38": "Minas Gerais",
    "41": "Paraná", "42": "Paraná", "43": "Paraná", "44": "Paraná", "45": "Paraná", "46": "Paraná",
    "47": "Santa Catarina", "48": "Santa Catarina", "49": "Santa Catarina",
    "51": "Rio Grande do Sul", "53": "Rio Grande do Sul", "54": "Rio Grande do Sul", "55": "Rio Grande do Sul",
    "61": "Distrito Federal/Goiás", "62": "Goiás", "63": "Tocantins", "64": "Goiás",
    "65": "Mato Grosso", "66": "Mato Grosso", "67": "Mato Grosso do Sul",
    "68": "Acre", "69": "Rondônia",
    "71": "Bahia", "73": "Bahia", "74": "Bahia", "75": "Bahia", "77": "Bahia",
    "79": "Sergipe",
    "81": "Pernambuco", "82": "Alagoas", "83": "Paraíba", "84": "Rio Grande do Norte", "85": "Ceará", "86": "Piauí", "87": "Pernambuco", "88": "Ceará", "89": "Piauí",
    "91": "Pará", "92": "Amazonas", "93": "Pará", "94": "Pará", "95": "Roraima", "96": "Amapá", "97": "Amazonas", "98": "Maranhão", "99": "Maranhão",
};

const ExpandableAvatar = ({ contact }) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Avatar
                src={contact?.urlPicture}
                style={{ width: "40px", height: "40px", margin: "0 auto", border: "2px solid #6517ab", cursor: "pointer" }}
                onClick={() => setOpen(true)}
            />
            <Dialog open={open} onClose={() => setOpen(false)}>
                <img src={contact?.urlPicture} alt="Contact" style={{ maxWidth: "90vw", maxHeight: "90vh" }} />
            </Dialog>
        </>
    );
};

const reducer = (state, action) => {
    if (action.type === "LOAD_CONTACTS") {
        const contacts = action.payload;
        const newContacts = [];
        contacts.forEach((contact) => {
            const contactIndex = state.findIndex((c) => c.id === contact.id);
            if (contactIndex !== -1) { state[contactIndex] = contact; } else { newContacts.push(contact); }
        });
        return [...state, ...newContacts];
    }
    if (action.type === "UPDATE_CONTACTS") {
        const contact = action.payload;
        const contactIndex = state.findIndex((c) => c.id === contact.id);
        if (contactIndex !== -1) { state[contactIndex] = contact; return [...state]; } else { return [contact, ...state]; }
    }
    if (action.type === "DELETE_CONTACT") {
        const contactId = action.payload;
        const contactIndex = state.findIndex((c) => c.id === contactId);
        if (contactIndex !== -1) { state.splice(contactIndex, 1); }
        return [...state];
    }
    if (action.type === "RESET") { return []; }
};

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(2),
        overflowY: "scroll",
        backgroundColor: theme.palette.background.default,
        border: "none",
        ...theme.scrollbarStyles,
    },

    headerContainer: {
        background: "linear-gradient(90deg, #6517ab 0%, #8e44ad 100%)",
        padding: theme.spacing(3),
        borderRadius: "0 0 20px 20px",
        color: "white",
        marginBottom: theme.spacing(3),
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    },
    headerTitle: {
        fontSize: "2rem",
        fontWeight: "bold",
        marginBottom: theme.spacing(1),
    },
    headerSubtitle: {
        fontSize: "1rem",
        opacity: 0.9,
        marginBottom: theme.spacing(2),
    },
    searchPaper: {
        padding: "4px 16px",
        display: "flex",
        alignItems: "center",
        borderRadius: "15px",
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        "& .MuiInputBase-root": { color: "white" },
        "& .MuiInputBase-input::placeholder": { color: "rgba(255, 255, 255, 0.7)", opacity: 1 },
    },
    addButton: {
        background: "white",
        color: "#6517ab",
        borderRadius: "15px",
        padding: "10px 20px",
        fontWeight: "600",
        textTransform: "none",
        "&:hover": {
            background: "#f0f0f0",
        },
    },
    importButton: {
        background: "rgba(255, 255, 255, 0.2)",
        color: "white",
        borderRadius: "12px",
        padding: "10px 20px",
        fontWeight: "600",
        textTransform: "none",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        "&:hover": { background: "rgba(255, 255, 255, 0.3)" },
    },
    tabsContainer: {
        marginBottom: theme.spacing(2),
        "& .MuiTabs-indicator": { backgroundColor: "#6517ab", height: 3, borderRadius: "3px 3px 0 0" },
        "& .MuiTab-root": { 
            fontWeight: 600, 
            textTransform: "none", 
            fontSize: "1rem", 
            color: theme.palette.text.secondary, 
            "&.Mui-selected": { color: "#6517ab" } 
        },
    },

    premiumCard: {
        borderRadius: "20px",
        transition: "all 0.3s ease",
        border: "none",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
        background: theme.palette.background.paper,
        "&:hover": { transform: "translateY(-5px)", boxShadow: "0 10px 25px rgba(0,0,0,0.1)" },
    },

    cardContent: {
        padding: theme.spacing(3),
        flexGrow: 1,
    },
    iconButton: {
        borderRadius: "12px",
        margin: theme.spacing(0, 0.5),
        transition: "all 0.2s",
        "&:hover": {
            transform: "scale(1.1)",
        },
    },
    legendCard: {
        backgroundColor: "rgba(101, 23, 171, 0.05)",
        borderRadius: "15px",
        marginBottom: theme.spacing(2),
    },
    legendContainer: { display: "flex", flexWrap: "wrap", gap: "15px" },
    legendItem: { display: "flex", alignItems: "center", gap: "8px" },
    legendColor: { width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#6517ab" },
}));

const Contacts = () => {
    const classes = useStyles();
    const history = useHistory();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { user, socket } = useContext(AuthContext);
    const { setCurrentTicket } = useContext(TicketsContext);
    const { getAll: getAllSettings } = useCompanySettings();

    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchParam, setSearchParam] = useState("");
    const [contacts, dispatch] = useReducer(reducer, []);
    const [selectedContactId, setSelectedContactId] = useState(null);
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [importContactModalOpen, setImportContactModalOpen] = useState(false);
    const [deletingContact, setDeletingContact] = useState(null);
    const [ImportContacts, setImportContacts] = useState(null);
    const [blockingContact, setBlockingContact] = useState(null);
    const [unBlockingContact, setUnBlockingContact] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
    const [contactTicket, setContactTicket] = useState({});
    const fileUploadRef = useRef(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [importWhatsappId, setImportWhatsappId] = useState();
    const [hideNum, setHideNum] = useState(false);
    const [enableLGPD, setEnableLGPD] = useState(false);
    const [tabValue, setTabValue] = useState("table");

    useEffect(() => {
        async function fetchData() {
            const settingList = await getAllSettings(user.companyId);
            for (const [key, value] of Object.entries(settingList)) {
                if (key === "enableLGPD") setEnableLGPD(value === "enabled");
                if (key === "lgpdHideNumber") setHideNum(value === "enabled");
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        dispatch({ type: "RESET" });
        setPageNumber(1);
    }, [searchParam, selectedTags]);

    useEffect(() => {
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    const { data } = await api.get("/contacts/", {
                        params: { searchParam, pageNumber, contactTag: JSON.stringify(selectedTags) },
                    });
                    dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
                    setHasMore(data.hasMore);
                    setLoading(false);
                } catch (err) { toastError(err); }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchParam, pageNumber, selectedTags]);

    useEffect(() => {
        const companyId = user.companyId;
        const onContactEvent = (data) => {
            if (data.action === "update" || data.action === "create") dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
            if (data.action === "delete") dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        };
        socket.on(`company-${companyId}-contact`, onContactEvent);
        return () => socket.off(`company-${companyId}-contact`, onContactEvent);
    }, [socket]);

    const handleSearch = (event) => setSearchParam(event.target.value.toLowerCase());
    const handleTabChange = (event, newValue) => setTabValue(newValue);
    const handleAddContact = () => { setSelectedContactId(null); setContactModalOpen(true); };
    const handleEditContact = (contactId) => { setSelectedContactId(contactId); setContactModalOpen(true); };

    const handleDeleteContact = async (contactId) => {
        try { await api.delete(`/contacts/${contactId}`); toast.success(i18n.t("contacts.toasts.deleted")); } catch (err) { toastError(err); }
        setDeletingContact(null); setSearchParam(""); setPageNumber(1);
    };

    const handleBlockContact = async (contactId) => {
        try { await api.put(`/contacts/block/${contactId}`, { active: false }); toast.success("Contato bloqueado"); } catch (err) { toastError(err); }
        setBlockingContact(null); setSearchParam(""); setPageNumber(1);
    };

    const handleUnBlockContact = async (contactId) => {
        try { await api.put(`/contacts/block/${contactId}`, { active: true }); toast.success("Contato desbloqueado"); } catch (err) { toastError(err); }
        setUnBlockingContact(null); setSearchParam(""); setPageNumber(1);
    };

    const handleImportExcel = async () => {
        try {
            const formData = new FormData();
            formData.append("file", fileUploadRef.current.files[0]);
            await api.post(`/contacts/upload`, formData);
            history.go(0);
        } catch (err) { toastError(err); }
    };

    const handleimportContact = async () => {
        try { await api.post("/contacts/import", { whatsappId: importWhatsappId }); history.go(0); } catch (err) { toastError(err); }
        setImportContactModalOpen(false);
    };

    const handleimportChats = async () => {
        try { await api.post("/contacts/import/chats"); history.go(0); } catch (err) { toastError(err); }
    };

    const handleScroll = (e) => {
        if (!hasMore || loading) return;
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollHeight - (scrollTop + 100) < clientHeight) setPageNumber((prev) => prev + 1);
    };

    const stateCounts = (() => {
        const counts = {};
        contacts.forEach(c => {
            const ddd = c.number?.substring(2, 4);
            const state = dddList[ddd] || "Outros";
            counts[state] = (counts[state] || 0) + 1;
        });
        return counts;
    })();

    const renderCardActions = (contact) => (
        <Box display="flex" gap={1} justifyContent="center" width="100%">
            <IconButton
                size="small"
                onClick={() => { setContactTicket(contact); setNewTicketModalOpen(true); }}
                className={classes.iconButton}
                style={{ backgroundColor: "#f3e5f5", color: "#6517ab" }}
                title="Conversar"
            >
                <WhatsApp fontSize="small" />
            </IconButton>
            <IconButton
                size="small"
                onClick={() => handleEditContact(contact.id)}
                className={classes.iconButton}
                style={{ backgroundColor: "#e3f2fd", color: "#1976d2" }}
                title="Editar"
            >
                <EditIcon fontSize="small" />
            </IconButton>
            <IconButton
                size="small"
                onClick={() => {
                    if (contact.active) { setBlockingContact(contact); setConfirmOpen(true); }
                    else { setUnBlockingContact(contact); setConfirmOpen(true); }
                }}
                className={classes.iconButton}
                style={{
                    backgroundColor: contact.active ? "#fff3e0" : "#e8f5e9",
                    color: contact.active ? "#ef6c00" : "#2e7d32"
                }}
                title={contact.active ? "Bloquear" : "Desbloquear"}
            >
                {contact.active ? <BlockIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
            </IconButton>
            <Can
                role={user.profile}
                perform="contacts-page:deleteContact"
                yes={() => (
                    <IconButton
                        size="small"
                        onClick={() => { setDeletingContact(contact); setConfirmOpen(true); }}
                        className={classes.iconButton}
                        style={{ backgroundColor: "#ffebee", color: "#d32f2f" }}
                        title="Excluir"
                    >
                        <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                )}
            />
        </Box>
    );

    return (
        <MainContainer className={classes.mainContainer}>
            <NewTicketModal
                modalOpen={newTicketModalOpen}
                initialContact={contactTicket}
                onClose={(ticket) => {
                    setNewTicketModalOpen(false);
                    if (ticket && ticket.uuid) history.push(`/tickets/${ticket.uuid}`);
                }}
            />
            <ContactModal
                open={contactModalOpen}
                onClose={() => setContactModalOpen(false)}
                contactId={selectedContactId}
            />
            <ConfirmationModal
                title={
                    deletingContact ? `Excluir ${deletingContact.name}?` :
                        blockingContact ? `Bloquear ${blockingContact.name}?` :
                            unBlockingContact ? `Desbloquear ${unBlockingContact.name}?` :
                                ImportContacts ? "Importar Contatos?" : "Ação"
                }
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={() => {
                    if (deletingContact) handleDeleteContact(deletingContact.id);
                    else if (blockingContact) handleBlockContact(blockingContact.id);
                    else if (unBlockingContact) handleUnBlockContact(unBlockingContact.id);
                    else if (ImportContacts) handleimportContact();
                }}
            >
                {deletingContact ? "Tem certeza que deseja excluir este contato?" :
                    blockingContact ? "Deseja bloquear este contato?" :
                        unBlockingContact ? "Deseja desbloquear este contato?" :
                            "Tem certeza que deseja prosseguir?"}
            </ConfirmationModal>

            <Box className={classes.headerContainer}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" className={classes.headerTitle}>Contatos</Typography>
                        <Typography className={classes.headerSubtitle}>Gerencie sua rede com elegância e eficiência</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="flex-end">
                            <Paper className={classes.searchPaper} elevation={0}>
                                <InputAdornment position="start">
                                    <SearchIcon style={{ color: "rgba(255,255,255,0.7)" }} />
                                </InputAdornment>
                                <TextField
                                    placeholder="Pesquisar..."
                                    value={searchParam}
                                    onChange={handleSearch}
                                    InputProps={{ disableUnderline: true }}
                                />
                            </Paper>
                            <PopupState variant="popover">
                                {(popupState) => (
                                    <>
                                        <Button
                                            variant="contained"
                                            className={classes.importButton}
                                            startIcon={<ArrowDropDown />}
                                            {...bindTrigger(popupState)}
                                        >
                                            Ações
                                        </Button>
                                        <Menu {...bindMenu(popupState)}>
                                            <MenuItem onClick={() => { setImportContactModalOpen(true); popupState.close(); }}>
                                                <Backup fontSize="small" style={{ marginRight: 8 }} /> Importar WhatsApp
                                            </MenuItem>
                                            <MenuItem onClick={() => { fileUploadRef.current.click(); popupState.close(); }}>
                                                <FileUploadIcon fontSize="small" style={{ marginRight: 8 }} /> Importar Excel
                                            </MenuItem>
                                        </Menu>
                                    </>
                                )}
                            </PopupState>
                            <Button
                                variant="contained"
                                className={classes.addButton}
                                startIcon={<AddIcon />}
                                onClick={handleAddContact}
                            >
                                Novo Contato
                            </Button>
                            <input type="file" ref={fileUploadRef} style={{ display: 'none' }} onChange={handleImportExcel} accept=".xls,.xlsx" />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                className={classes.tabsContainer}
            >
                <Tab label="Tabela" value="table" />
                <Tab label="Grade" value="grid" />
                <Tab label="Mapa" value="map" />
            </Tabs>

            <Paper className={classes.mainPaper} elevation={0} onScroll={handleScroll}>
                {tabValue === "table" && (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Avatar</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell align="center">Número</TableCell>
                                <TableCell align="center">Email</TableCell>
                                <TableCell align="center">Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contacts.map((contact) => (
                                <TableRow key={contact.id}>
                                    <TableCell align="center"><ExpandableAvatar contact={contact} /></TableCell>
                                    <TableCell><Typography variant="body1" style={{ fontWeight: 500 }}>{contact.name}</Typography></TableCell>
                                    <TableCell align="center">{contact.number}</TableCell>
                                    <TableCell align="center">{contact.email || "---"}</TableCell>
                                    <TableCell align="center">{renderCardActions(contact)}</TableCell>
                                </TableRow>
                            ))}
                            {loading && <TableRowSkeleton columns={5} />}
                        </TableBody>
                    </Table>
                )}

                {tabValue === "grid" && (
                    <Grid container spacing={3}>
                        {contacts.map((contact) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={contact.id}>
                                <Card className={classes.premiumCard} elevation={0}>
                                    <CardContent className={classes.cardContent}>
                                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                                            <ExpandableAvatar contact={contact} />
                                            <Chip
                                                label={contact.active ? "Ativo" : "Bloqueado"}
                                                size="small"
                                                style={{ backgroundColor: contact.active ? "#f3e5f5" : "#ffebee", color: contact.active ? "#6517ab" : "#d32f2f", fontWeight: 600 }}
                                            />
                                        </Box>

                                        <Typography variant="body1" color="textPrimary" style={{ fontWeight: 500, marginBottom: "8px", minHeight: "24px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                            {contact.name || "Sem Nome"}
                                        </Typography>

                                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                                            <WhatsApp style={{ color: "#25D366", fontSize: "1rem" }} />
                                            <Typography variant="body2" style={{ opacity: 0.8 }}>{contact.number}</Typography>
                                        </Box>

                                        {contact.email && (
                                            <Typography variant="body2" style={{ opacity: 0.6, fontSize: "0.85rem", marginBottom: "16px", display: "block" }}>
                                                {contact.email}
                                            </Typography>
                                        )}

                                        <Divider style={{ margin: "16px 0" }} />

                                        {renderCardActions(contact)}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}

                {tabValue === "map" && (
                    <Box p={3}>
                        <Card className={classes.legendCard} elevation={0}>
                            <CardContent>
                                <Box className={classes.legendContainer}>
                                    {Object.entries(stateCounts).map(([state, count]) => (
                                        <Box key={state} className={classes.legendItem}>
                                            <div className={classes.legendColor} />
                                            <Typography variant="body2" style={{ fontWeight: 600 }}>{state}: {count}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </CardContent>
                        </Card>
                        <ComposableMap
                            projection="geoMercator"
                            projectionConfig={{ scale: 600, center: [-53, -15] }}
                            style={{ width: "100%", height: "auto" }}
                        >
                            <Geographies geography={geoUrl}>
                                {({ geographies }) => geographies.map((geo) => {
                                    const state = geo.properties.name;
                                    const count = stateCounts[state] || 0;
                                    return (
                                        <Geography
                                            key={geo.rsmKey}
                                            geography={geo}
                                            fill={count > 0 ? "#6517ab" : "#EAEAEC"}
                                            stroke="#D6D6DA"
                                            style={{ hover: { fill: "#8e44ad" } }}
                                        />
                                    );
                                })}
                            </Geographies>
                            {markers.map(({ name, coordinates, markerOffset }) => (
                                <Marker key={name} coordinates={coordinates}>
                                    <circle r={5} fill="#F00" stroke="#fff" strokeWidth={1} />
                                    <text textAnchor="middle" y={markerOffset} style={{ fontFamily: "Inter, sans-serif", fill: "#5D5A6D", fontSize: "12px", fontWeight: 600 }}>{name}</text>
                                    {stateCounts[name] && <text textAnchor="middle" y={markerOffset + 15} style={{ fontFamily: "Inter, sans-serif", fill: "#6517ab", fontSize: "10px", fontWeight: "bold" }}>{stateCounts[name]} contatos</text>}
                                </Marker>
                            ))}
                        </ComposableMap>
                    </Box>
                )}
            </Paper>

            {importContactModalOpen && (
                <ContactImportWpModal
                    isOpen={importContactModalOpen}
                    handleClose={() => setImportContactModalOpen(false)}
                    selectedTags={selectedTags}
                />
            )}
        </MainContainer>
    );
};

export default Contacts;